<template>
  <div id="app">
    <nav-bar/>
    <RouterView />
  </div>
</template>

<script>
  import NavBar from "@/components/assets/NavBar.vue";
  export default {
    name: 'App',
    components: {
      NavBar
    }
  }
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  background-color: #f3e5f5; /* Tono pastel de lavanda */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
}
</style>
